import { doc } from "firebase/firestore";
import { db } from "../firebase";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { useCallback, useState } from "react";
import { updateDoc } from "firebase/firestore";

export const useDoc = (collection, id) => {
  const docRef = collection && id ? doc(db, collection, id) : undefined;
  const [data, loading, loadError] = useDocumentData(docRef);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState(undefined);
  const update = useCallback(
    async (data) => {
      setSaving(true);
      try {
        await updateDoc(docRef, data);
        setSaveError(undefined);
        setSaving(false);
        return true;
      } catch (error) {
        setSaveError(error);
        setSaving(false);
        return false;
      }
    },
    [docRef, setSaving, setSaveError]
  );
  return { data, loading, loadError, docRef, update, saveError, saving };
};
